export default __webpack_public_path__ + "static/media/PG19-2.b9171c6e.png";